import { Injectable } from '@angular/core';
import { formatDateFromCalendar, formatDatePublish } from '../shared/utils';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Archive } from '../models/archive.model';

declare let ga: any;

@Injectable({ providedIn: 'root' })
export class GaEventTrackerProvider {

  constructor(private gtmService: GoogleTagManagerService) {}

  trackEvent(newspaper, eventType, label, value) { }

  trackCouponEvent(eventName, eventType, label, value) {
    // ga('send', 'event', eventName, eventType, label, value);
  }

  gaSendUserId(id: string) {
    // ga('set', 'userId', id);
  }

  public sendPDFDownloadReader(pdf: Archive, type: string) {
    const pdfData = formatDatePublish(pdf.publish_on);
    const gtmTag = {
      event: `pdf-${type}`,
      name: pdf.newspaper_name,
      subname: pdf.newspaper_subname,
      fromDate: formatDateFromCalendar({ year:pdfData.getFullYear(), month:pdfData.getMonth() + 1, day:pdfData.getDate() }),
      publishNumber: pdf.publish_number.toString()
    };

    this.gtmService.pushTag(gtmTag); 
  }

  public sendAudioArticle(newspaper: string, category: string, slug: string) {
    const gtmTag = { event: 'audio-article', newspaper, category, slug };

    this.gtmService.pushTag(gtmTag); 
  }

  public sendVideoArticle(newspaper: string, slug: string) {
    const gtmTag = { event: 'video-article', newspaper, slug };

    this.gtmService.pushTag(gtmTag); 
  }
}
